// ════════════════════════════════════════════════════════════
//  online/together.js — WHERE IS MY FRIEND? (one read, plain answer)
// ════════════════════════════════════════════════════════════
//  caP'n 2026-10-18: "click on each other's Mark and easily join whatever room
//  they're in … If they're in Shatterproof etc, you can spectate as normal".
//  Reads the two pointers a player leaves behind (both under the open
//  games/shatterproof drawer, both removed when they leave or drop):
//    inRoom/{uid}  = their room code, while they're on the room screen
//    where/{uid}   = the fight they're watching (+ which box, + waiting) or the
//                    online fight they're FIGHTING in (f: 1, + the room it's from)
//  → { kind, room, match, box, pub, name }
//    kind: "roomfight" (fighting a room fight → join the room, it sends you to watch)
//          "fight"     (fighting, no room → watch it)
//          "room"      (on a room screen → join the room)
//          "wait"      (waiting for their partner in a Sky Box → join their box)
//          "watch"     (watching a fight → sit with them)
//          "none"
//  App's joinFriend() turns the kind into the one right move. The Join bar
//  under a Mark, the friends list's ⋯ and a CALL all use it, and so does
//  Lyraei's seat (partnerState).
// ════════════════════════════════════════════════════════════
import { fbNet } from "./net.js";
import { BASE } from "./ie.js";
import { whereIs } from "./skybox.js";

export const ROOM_CODE = /^[A-Z]{4}$/;

/** Pure: the two pointers → the answer (tested by tools/together-check.mjs). */
export function readWhereabouts(room, w, uid) {
  if (w && w.f && w.match) return { kind: w.room && ROOM_CODE.test(w.room) ? "roomfight" : "fight", room: w.room && ROOM_CODE.test(w.room) ? w.room : null, match: w.match, name: w.name || null };
  if (typeof room === "string" && ROOM_CODE.test(room)) return { kind: "room", room };
  if (w && w.match) return { kind: w.w ? "wait" : "watch", match: w.match, box: w.box || uid, pub: !!w.p, name: w.name || null };
  return { kind: "none" };
}

export async function whereabouts(uid, net = fbNet) {
  if (!uid) return { kind: "none" };
  const [room, w] = await Promise.all([net.get(`${BASE}/inRoom/${uid}`).catch(() => null), whereIs(uid)]);
  return readWhereabouts(room, w, uid);
}
